export const environment = {
  apiUrl: 'https://api.new.the-carp-specialist.staging.novon.dev',
  googleMapsApiKey: 'AIzaSyCWPq2vONr5Ou4A51Gj-Ly469HoW0Qo-JQ',
};
